// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ja21F","header":"ReportDetails_header__VupgS","title":"ReportDetails_title__vSlar","left":"ReportDetails_left__25YsV"};